module.exports = __webpack_public_path__ + "static/media/img_19.5e15eb86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_19.jpg
// module id = 537
// module chunks = 0